{
  "invoicingAccounts": {
    "title": "Invoicing account",
    "overrideCheckboxLabel": "Override inherited",
    "invoicingAccountDropdownLabel": "Select invoicing account",
    "accountNotValidTitle": "Wrong account",
    "accountNotValidMessage": "This invoicing account is not used anymore. Select correct account from the list.",
    "userGroupAccountNotValidMessage": "The user group’s invoicing account is not used anymore.",
    "accountNotValidLabel": "Account not found",
    "saveButton": "SAVE CHANGES",
    "cancelButton": "CANCEL",
    "noInvoicingAccountsInfo": "No invoicing account options found",
    "saveErrorTitle": "Error",
    "saveErrorMessage": "Saving invoicing account info failed",
    "dropdownHelperText": "If the invoicing account is not selected, inherited invoicing account is used."
  }
}
